import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const StaticPage = ({ icon: Icon, title, intro, children, testid }) => (
  <div data-testid={testid}>
    <section className="hero-swoosh">
      <div className="max-w-[900px] mx-auto px-5 pt-8 pb-8 relative z-10">
        <div className="flex items-center gap-1.5 text-[14px] text-slate-400 mb-4">
          <Link to="/" className="hover:text-[#FF3B3B]">Accueil</Link>
          <ChevronRight size={15} />
          <span className="text-slate-50 font-semibold">{title}</span>
        </div>
        <h1 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-3xl md:text-5xl mb-2 flex items-center gap-3">
          {Icon && <Icon className="text-[#FF3B3B]" size={40} />} {title}
        </h1>
        {intro && <p className="text-slate-400">{intro}</p>}
      </div>
    </section>
    <section className="max-w-[900px] mx-auto px-5 py-8">
      <div className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-6 md:p-8 space-y-6 leading-relaxed text-slate-300">
        {children}
      </div>
    </section>
  </div>
);

export const Block = ({ title, children }) => (
  <div>
    {title && <h2 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-xl md:text-2xl mb-2">{title}</h2>}
    <div className="space-y-2 text-[15px]">{children}</div>
  </div>
);
